// WARNING. This content was autogenerated.
// Generated: 2026-10-13T18:38:49.891Z
// Do not edit.
import type { TypePolicies } from '@apollo/client/core';

/**
 * Merge policies for GraphQL namespace types (e.g. ProfileQuery, ContactMutation).
 *
 * These types act as containers for namespaced query/mutation fields. Without
 * `merge: true`, querying a different field under the same namespace replaces
 * the entire cached object, evicting sibling fields and triggering unnecessary
 * refetches.
 *
 * Regenerated by `gen-namespace-type-policies.ts` whenever the schema changes.
 */
export const namespaceTypePolicies: TypePolicies = {
    ContactMutation: { merge: true },
    ContactQuery: { merge: true },
    CredentialMutation: { merge: true },
    CredentialQuery: { merge: true },
    HistoryQuery: { merge: true },
    ProfileMutation: { merge: true },
    ProfileQuery: { merge: true },
    ServicesMutation: { merge: true },
    ServicesQuery: { merge: true },
    ServiceSubscriptionConfigAttributesSchemaMutation: { merge: true },
    ServiceSubscriptionConfigAttributesSchemaQuery: { merge: true },
    ServiceSubscriptionConfigMutation: { merge: true },
    ServiceSubscriptionConfigQuery: { merge: true },
    ServiceSubscriptionMutation: { merge: true },
    ServiceSubscriptionQuery: { merge: true },
};
